import type { onNavigate } from '@otto-ec/global-resources/navigation';
import type { SelectionState, SelectionUpdate } from '@tilelist/application/ports/SelectionEvents.ts';
import { isCheckpoint, navigationInfo } from './SelectionNavigation.browser.ts';
import { sameSelectionExceptUrl } from './SelectionState.ts';

type NavigationEvent = Parameters<Parameters<typeof onNavigate.subscribe>[0]>[0];

export function handleSelectionNavigation(
    event: NavigationEvent,
    checkpoint: unknown,
    commit: (update: SelectionUpdate, destinationUrl: string) => void,
    current?: SelectionState,
): void {
    if (!isCheckpoint(checkpoint)) return;
    /*                                                                                                    */
    /*                                                                                                  */
    if (event.type === 'popstate' && current && sameSelection(checkpoint, current)) return;
    const info = navigationInfo(event.info);
    const source = event.type === 'popstate' ? 'historic' : info?.source;
    if (!source || info?.initialize) return;
    event.onComplete((result) => {
        if (!result.cancelled) commit({ selection: checkpoint, source }, event.destination.url.href);
    });
}

function sameSelection(a: SelectionState, b: SelectionState): boolean {
    return a.url === b.url && sameSelectionExceptUrl(a, b);
}
